export default __webpack_public_path__ + "static/media/addTransperent.05bfc0a6.svg";